<template>
  <div class="cardLayoutWrapper cardLayoutWrapper--header">
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-3 elem--clickable elem--sort">
      <BasicSort
        v-model="modelValue"
        name="id"
      />
      <span>Numéro</span>
    </div>
    <div class="elem elem--span-2 elem--sort">
      <BasicSort
        v-model="modelValue"
        name="dispositif"
      />
      <span>Disp</span>
    </div>
    <div class="elem elem--span-6 elem--clickable elem--sort">
      <BasicSort
        v-model="modelValue"
        name="intitule"
      />
      <span>Formation</span>
    </div>
    <div class="elem elem--span-3 elem--clickable elem--sort">
      <BasicSort
        v-model="modelValue"
        name="start"
      />
      <span>Début</span>
    </div>
    <div class="elem elem--span-3 elem--clickable elem--sort">
      <BasicSort
        v-model="modelValue"
        name="end"
      />
      <span>Fin</span>
    </div>
    <div class="elem elem--span-5">
      <span>Entreprise</span>
    </div>
    <div class="elem elem--span-4">
      <span>Stagiaire(s)</span>
    </div>
    <div class="elem elem--span-4 elem--clickable elem--sort">
      <BasicSort
        v-model="modelValue"
        name="statut"
      />
      <span>Etat</span>
    </div>
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-1"></div>
    <div class="elem elem--span-1"></div>
  </div>
</template>

<script setup lang="ts">
  const modelValue = defineModel<string>()
</script>
